import { api } from './api';

export const chatbotApi = {
  sendMessage: (data: {
    message: string;
    conversationId?: string;
    context: { currentPage: string };
  }) => api.post<{
    conversationId: string;
    messageId: string;
    answer: string;
  }>('/chatbot/messages', data),

  submitFeedback: (messageId: string, feedback: 'helpful' | 'not_helpful') =>
    api.post(`/chatbot/messages/${messageId}/feedback`, { feedback }),
};
